/*
 * The cart: the drawer, the header count, add to cart, and quantity changes.
 *
 * Everything here upgrades something that already works without it. The
 * header's cart link goes to /cart, the product form posts to /cart/add, and
 * the cart form posts updates[] and checkout. With script, adding and changing
 * go through Shopify's Ajax cart and the drawer re-renders from its own section
 * (Section Rendering API), so the markup has one source: dg-cart-contents.
 *
 * After every change the header count, its accessible name, and dg_state's
 * cart.n are set from the count Shopify returns, never from arithmetic here.
 *
 * THE OFFERS ("You may also like", dg-cart-offers.liquid, cart-redesign
 * piece 3) are plain forms: an add posts /cart/add, a replace posts
 * /cart/update. Here they go by fetch with the same fields and re-render like
 * a quantity change.
 *
 * THE OFFER ROW'S ARROWS (tweak round 5, item 2, owner ruling, 7 Oct 2026).
 * With a fine pointer and hover, the row hides its scrollbar and its two
 * arrows show while the cards overflow; each press moves the row one card
 * (a card's width and the gap) by the browser's smooth scroll, instant under
 * prefers-reduced-motion, and an arrow is aria-disabled at its end. On touch
 * nothing shows and the row swipes natively. Re-wired after every render.
 *
 * THE DISCOUNT CODE (cart-redesign piece 5) is a plain form posting discount
 * to /cart/update. Here it goes to /cart/update.js the same way, so the
 * shipping status and the totals re-render with the code applied. A code
 * Shopify does not apply shows the row's error, open, under the field; on
 * /cart, which reloads after a change, the refusal crosses the reload in
 * ?dg-code and the parameter is then dropped (owner, 9 Oct 2026). Remove
 * (data-dg-code-remove, owner brief, 25 Oct 2026) is the same kind of form,
 * posting the cart's other codes, and goes the same way; it is never judged
 * refused, sends no event and plays no celebration. That includes
 * cart_free_shipping_reached: a removal that takes the cart back over the
 * threshold redraws the band and the shipping row, and nothing else (owner
 * brief, 25 Oct 2026).
 *
 * THE PRICING RULE FOR GRANDPARENT GUIDES (cart-redesign piece 4, owner,
 * 7 Oct 2026; replaces the 6 Oct removal rule; packs qualify from 27 Oct 2026,
 * pricing-catalog.md at daisysguide-brain 2fd3c0e › Add-on to any parent
 * order; qualification and every cart with a guide, owner, 27 Oct 2026). One
 * decision, conversion(), runs once after every change and once on load, on
 * every cart holding a grandparent guide. It counts the grandparent copies
 * (quantity x unit_count, add-ons 1) and finds their cheapest mix at the
 * variants' own prices, where add-ons are at most four (ADDON_CAP, the
 * checkout function's cap) and need a qualifying line or a listed variant of
 * more than one copy (the x2 or x4) beside them. A line qualifies by the
 * checkout function's own test: it requires shipping and is not a grandparent
 * guide (data-dg-qualifies); addon_eligible is not read here, it decides only
 * where the add-on is offered. So with a qualifying line up to four copies are
 * add-ons; without one, three copies are a x2 and an add-on, four a x4, five
 * to eight a x4 and add-ons, and an add-on with only single copies becomes
 * listed copies. The cart is changed only when checkout
 * would refuse it or the mix costs more than the cheapest; a guide is never
 * removed, only moved to another variant. It is applied in one
 * /cart/update.js call and never re-run on its own result: after it, the cart
 * holds the cheapest mix, which the rule leaves alone, so it settles in one
 * pass and cannot loop. When it raised the total, the
 * pricing notice shows above the lines, with Undo when the change before it
 * removed lines: Undo adds those lines back at the quantities removed, and the
 * rule then restores the lower price. Undo is offered until the next change
 * (whose render draws the notice hidden) or until the drawer closes. On /cart,
 * which reloads after a change, the notice and its Undo cross the reload in
 * ?dg-price (variant:quantity pairs) and the parameter is then dropped. A
 * conversion that lowers the total shows the lowering notice instead, with no
 * Undo (owner, 27 Oct 2026), crossing the reload as ?dg-price=lower. One
 * notice per settle, from one comparison of the total before and after the
 * conversion: the raising notice when it rose, which wins should both ever
 * apply, the lowering one when it fell, none when it is the same. The
 * lowering notice is not shown on the settle that follows an Undo. Only the
 * raising notice is reported as cart_pricing_notice_shown, as before. With no
 * script the rule cannot run.
 *
 * A SMALL CELEBRATION WHEN MONEY IS SAVED (tweak round 6, item 2, owner
 * ruling, 8 Oct 2026: a deliberate exception to the shop's motion limits).
 * The theme's own sparkles (dg-sparkles.js and dg-sparkles.css: the same
 * star, classes and 700ms twinkle) play once, for under a second, at three
 * moments only: the shipping band goes from away to reached; the Combine
 * button's change has landed; a discount code is applied. Twelve sparkles,
 * 18 to 28px, scattered over the whole band or line, over its words too
 * (tweak round 8, item 1). The cart renders
 * first and the sparkles play over it, so nothing waits for them. Never on
 * load, on opening the cart, or when the saving went down. After a combine
 * the saving line reads "Nice. You just saved {amount}." for 3 seconds, then
 * its usual words. Under prefers-reduced-motion nothing is drawn (the band
 * still turns green and the words still change). The sparkles are
 * aria-hidden; the saving line's new words are announced politely, from a
 * live region outside the re-rendered body. On /cart, which reloads after a
 * change, the moment crosses the reload in ?dg-joy, as the notice does.
 *
 * The product page's summary band plays the same celebration through
 * dg:celebrate (tweak round 8, item 2; dg-product.js decides when).
 *
 * AFTER A SUCCESSFUL ADD from a product form, that form receives dg:added
 * (pdp-redesign tweak round 1, owner, 7 Oct 2026): the product page then stops
 * counting its selection toward free shipping, because the cart holds it.
 * WHEN SHOPIFY REFUSES an add from a form holding the gift card's recipient
 * form (422), that form receives dg:add-error with Shopify's message and
 * errors (tweak round 9, item 6c; assets/dg-recipient-form.js shows them).
 *
 * THE INBOUND ADD (owner brief, 24 Oct 2026). Another site (the apex quiz)
 * sends a shopper to /cart?dg_add=<variant>:<qty>,... with several lines.
 * snippets/dg-cart-inbound.liquid has already taken dg_add out of the address,
 * before the page view could carry it, and left its value on <html
 * data-dg-add>. Here, on /cart only: a line is kept when its variant is
 * numeric and its quantity a whole 1 to 8, the first six kept lines at most;
 * anything else is passed over, not the whole request. The kept lines go in
 * one /cart/add.js call, onto the cart as it is (never cleared), and then
 * through settle(), as a product form's add does, so the grandparent rule
 * above prices any add-on it brings. Then /cart reloads with the new lines.
 * When a line was passed over or Shopify refused the add, the notice above the
 * lines shows ("We couldn't add everything"), across the reload in ?dg-short;
 * with no answer at all from Shopify, the page stays, notice shown, on the
 * cart as it was drawn. It sends no event of its own.
 *
 * THE THEME'S OWN PARAMETERS on /cart (dg-price, dg-joy, dg-code, dg-short)
 * are dropped and set by cutting the query at &, so every other parameter
 * stays byte for byte as it arrived (attribution reads them).
 *
 * BEHAVIOUR EVENTS (shop events, owner brief, 9 Oct 2026), through
 * DGEvents.track (assets/dg-events.js, which decides whether anything is
 * sent). On /cart each goes by sendBeacon, since a change there reloads.
 *   cart_opened              source: add | icon | page. page is a fresh load
 *                            of /cart, not its reload after a change.
 *   cart_offer_shown         type, once per offer per cart view: a drawer
 *                            view lasts from opening to closing, a /cart view
 *                            across its own reloads. An offer is its type and
 *                            its place among offers of that type.
 *   cart_offer_accepted      type, value_change (the cart total after the
 *                            rule, minus before, in the shop's currency)
 *   cart_item_removed        a line taken to 0 by the shopper: Remove, the
 *                            stepper or the field. Never the rule or an offer.
 *   cart_pricing_notice_shown  when the notice is drawn where it can be seen
 *   cart_undo_pressed
 *   cart_discount_applied    success: true | false. The code is never sent.
 *   cart_free_shipping_reached  the band goes from away to reached, by any
 *                            change but a code's removal
 *   cart_checkout_started    method: button. Shopify's wallet buttons are
 *                            not observed (see the run log).
 */
(() => {
  const root = window.Shopify?.routes?.root ?? '/';
  const SECTION = 'dg-cart-drawer';
  const dialog = document.querySelector('[data-dg-cart]');
  const onCartPage = Boolean(document.querySelector('[data-dg-cart-page]'));
  const NOTICE = 'dg-price';
  const JOY = 'dg-joy';
  const CODE = 'dg-code';
  const SHORT = 'dg-short';

  // /cart's address with the theme's own parameters dropped, then set, and
  // every other parameter as it arrived, in its order.
  function address(set = {}) {
    const own = [NOTICE, JOY, CODE, SHORT];
    const kept = window.location.search.slice(1).split('&').filter((part) => part && !own.includes(part.split('=')[0]));
    for (const [name, value] of Object.entries(set)) kept.push(`${name}=${encodeURIComponent(value)}`);
    return `${window.location.pathname}${kept.length ? `?${kept.join('&')}` : ''}${window.location.hash}`;
  }

  // The lines the pricing notice's Undo would put back, or null.
  let undo = null;

  const track = (name, props = {}, origin = null) => window.DGEvents?.track(name, props, { origin, beacon: onCartPage });
  // The offers already reported in this cart view (type:place).
  let seen = new Set();
  // A notice drawn into the closed drawer, reported when it opens.
  let noticeUnseen = false;

  function reportOffers() {
    const container = onCartPage ? document.querySelector('[data-dg-cart-page]') : dialog;
    if (!container) return;
    const places = {};
    for (const form of container.querySelectorAll('form[data-dg-offer-type]')) {
      const type = form.dataset.dgOfferType;
      places[type] = (places[type] ?? 0) + 1;
      const key = `${type}:${places[type]}`;
      if (seen.has(key)) continue;
      seen.add(key);
      track('cart_offer_shown', { type }, form);
    }
  }

  const desktop = window.matchMedia('(hover: hover) and (pointer: fine)');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const resized = 'ResizeObserver' in window ? new ResizeObserver((entries) => entries.forEach((entry) => syncArrows(entry.target))) : null;

  // One card's travel: its width and the row's gap.
  function cardStep(row) {
    const card = row.querySelector('.dg-offer');
    return card ? card.getBoundingClientRect().width + (Number.parseFloat(getComputedStyle(row).columnGap) || 0) : row.clientWidth;
  }

  function syncArrows(row) {
    const arrows = row.closest('.dg-cart__offers')?.querySelector('[data-dg-offer-arrows]');
    if (!arrows) return;
    const on = desktop.matches;
    row.toggleAttribute('data-dg-arrows', on);
    const overflows = row.scrollWidth - row.clientWidth > 1;
    arrows.hidden = !(on && overflows);
    const [previous, next] = arrows.querySelectorAll('[data-dg-offer-step]');
    previous?.setAttribute('aria-disabled', String(row.scrollLeft <= 1));
    next?.setAttribute('aria-disabled', String(row.scrollLeft + row.clientWidth >= row.scrollWidth - 1));
  }

  function wireArrows() {
    for (const row of document.querySelectorAll('[data-dg-offer-row]')) {
      if (row.dgWired) continue;
      row.dgWired = true;
      row.addEventListener('scroll', () => syncArrows(row), { passive: true });
      resized?.observe(row);
      syncArrows(row);
    }
  }

  // THE CELEBRATION (tweak round 6, item 2). The star is dg-sparkles.js's,
  // and so are the three nested elements dg-sparkles.css animates; that file
  // is a byte port with no way in from outside, so the drawing is repeated
  // here rather than changed there.
  const NS = 'http://www.w3.org/2000/svg';
  const STAR = 'M34 0C36 22 46 32 68 34C46 36 36 46 34 68C32 46 22 36 0 34C22 32 32 22 34 0Z';
  const LIFE = 700;
  const COMBINED_FOR = 3000;
  let announcer = null;

  function announce(text) {
    if (!text) return;
    if (!announcer) {
      announcer = document.createElement('p');
      announcer.className = 'dg-visually-hidden';
      announcer.setAttribute('aria-live', 'polite');
      (dialog && !onCartPage ? dialog : document.body).append(announcer);
    }
    announcer.textContent = '';
    window.setTimeout(() => (announcer.textContent = text), 50);
  }

  // What the moments are told apart by: the band's state and the saving, in cents.
  function snapshot(body) {
    return {
      band: body?.querySelector('.dg-cart__status')?.dataset.state ?? null,
      saved: Number(body?.querySelector('[data-dg-saving]')?.dataset.dgSaved) || 0,
    };
  }

  // The moment a change made, or null. cause: { snap, combine (its amount), code,
  // removal }. A code's removal has none.
  function moment(cause, after) {
    const before = cause?.snap;
    if (!before || cause.removal) return null;
    if (after.saved < before.saved) return null;
    if (cause.combine) return { where: 'saving', combine: cause.combine };
    if (cause.code) return { where: 'saving' };
    if (before.band === 'away' && after.band === 'reached') return { where: 'band' };
    return null;
  }

  // TWELVE, SCATTERED OVER THE WHOLE HOST (tweak round 8, item 1, owner
  // ruling, 8 Oct 2026). One in each cell of a grid, at a random point inside
  // it, so together they cover the host's width and height without lining up.
  // Two rows on a host more than four times as wide as it is tall, three
  // otherwise. Sizes are spread from 18 to 28px (twice round 6's 9 to 14) and
  // shuffled, and each centre sits half its size in from the host's edge, so
  // none reaches past it. They may pass over the words: they are gone inside
  // the second. Each starts at 0, 60 or 120ms, as before.
  const COUNT = 12;
  const SMALLEST = 18;
  const LARGEST = 28;

  function shuffle(list) {
    for (let i = list.length - 1; i > 0; i -= 1) {
      const j = Math.floor(Math.random() * (i + 1));
      [list[i], list[j]] = [list[j], list[i]];
    }
    return list;
  }

  // AROUND A SMALL HOST (pdp-pill-sparkle, owner brief, 9 Oct 2026): the
  // notebooks row's free-shipping pill. around: the same twelve stars, sizes
  // times scale (the pill's height over the band's, which dg-product.js
  // measures), each in one twelfth of a ring just outside the host's edge, so
  // none covers its words; a centre is held inside the viewport, so nothing
  // overflows sideways. A new play replaces one still running on that host.
  function ring(width, height, size, at) {
    const w = width + size;
    const h = height + size;
    let d = at * 2 * (w + h);
    const x = -size / 2;
    const y = -size / 2;
    if (d < w) return [x + d, y];
    d -= w;
    if (d < h) return [x + w, y + d];
    d -= h;
    if (d < w) return [x + w - d, y + h];
    return [x, y + h - (d - w)];
  }

  function sparkle(host, { around = false, scale: factor = 1 } = {}) {
    if (!host || reduced.matches) return;
    host.classList.add('dg-sparkles');
    if (around) host.querySelector(':scope > .dg-sparkles__field')?.remove();
    const field = document.createElement('span');
    field.className = 'dg-sparkles__field';
    field.setAttribute('aria-hidden', 'true');
    const box = host.getBoundingClientRect();
    const rows = box.width > box.height * 4 ? 2 : 3;
    const columns = COUNT / rows;
    const sizes = shuffle(Array.from({ length: COUNT }, (_, i) => Math.round(factor * (SMALLEST + (i * (LARGEST - SMALLEST)) / (COUNT - 1)))));
    const cells = shuffle(Array.from({ length: COUNT }, (_, i) => i));
    const edge = document.documentElement.clientWidth;
    for (let i = 0; i < COUNT; i += 1) {
      const size = sizes[i];
      const outer = document.createElement('span');
      outer.className = 'dg-sparkle';
      if (around) {
        // The field starts inside the host's border; the ring is drawn from its outer edge.
        const left = box.left + host.clientLeft;
        let [x, y] = ring(box.width, box.height, size, (cells[i] + 0.15 + Math.random() * 0.7) / COUNT);
        x = Math.min(Math.max(x - host.clientLeft, size / 2 - left), edge - size / 2 - left);
        outer.style.left = `${x.toFixed(1)}px`;
        outer.style.top = `${(y - host.clientTop).toFixed(1)}px`;
      } else {
        const x = ((cells[i] % columns) + 0.15 + Math.random() * 0.7) / columns;
        const y = (Math.floor(cells[i] / columns) + 0.15 + Math.random() * 0.7) / rows;
        outer.style.left = `calc(${size / 2}px + ${x.toFixed(3)} * (100% - ${size}px))`;
        outer.style.top = `calc(${size / 2}px + ${y.toFixed(3)} * (100% - ${size}px))`;
      }
      outer.style.width = outer.style.height = `${size}px`;
      const scale = document.createElement('span');
      scale.className = 'dg-sparkle__scale';
      scale.style.animationDelay = `${(i % 3) * 60}ms`;
      const svg = document.createElementNS(NS, 'svg');
      svg.setAttribute('viewBox', '0 0 68 68');
      svg.setAttribute('class', 'dg-sparkle__spin');
      svg.style.animationDelay = scale.style.animationDelay;
      const path = document.createElementNS(NS, 'path');
      path.setAttribute('d', STAR);
      svg.append(path);
      scale.append(svg);
      outer.append(scale);
      field.append(outer);
    }
    host.prepend(field);
    // 700ms and the last start at 120ms: gone inside the second.
    window.setTimeout(() => field.remove(), LIFE + 160);
  }

  // THE PRODUCT PAGE'S BAND (tweak round 8, item 2). dg-product.js asks for
  // the celebration with dg:celebrate on its summary band, once per page view,
  // after the band and the total are drawn. The drawing is this one, so the
  // colour, count, size, timing and reduced motion match the cart's. Its
  // notebooks pill asks the same way, with { around, scale } as the detail.
  document.addEventListener('dg:celebrate', (event) => {
    if (event.target instanceof Element) sparkle(event.target, event.detail || undefined);
  });

  // Plays a moment over a body already on screen, and says the saving line's
  // new words. previous: the saving line's words before the change, if known.
  function celebrate(body, joy, previous = null) {
    const line = body?.querySelector('[data-dg-saving]');
    if (joy?.combine && line) {
      const said = (line.dataset.dgSavingCombined ?? '').replace('[amount]', joy.combine);
      if (said) {
        line.textContent = said;
        window.setTimeout(() => {
          if (line.isConnected) line.textContent = line.dataset.dgSavingText ?? line.textContent;
        }, COMBINED_FOR);
      }
      announce(said || line.textContent);
    } else if (line && line.textContent.trim() !== previous) {
      announce(line.textContent.trim());
    }
    if (!joy) return;
    const host = joy.where === 'band' ? body.querySelector('.dg-cart__status') : line ?? body.querySelector('.dg-cart__code > summary');
    sparkle(host);
  }

  function setCount(count) {
    for (const link of document.querySelectorAll('[data-dg-cart-link]')) {
      const badge = link.querySelector('[data-dg-cart-link-count]');
      const label = link.querySelector('[data-dg-cart-link-label]');
      if (badge) {
        badge.textContent = String(count);
        badge.hidden = count === 0;
      }
      if (label) {
        const template = count === 1 ? label.dataset.one : label.dataset.other;
        label.textContent = template.replace('[count]', String(count));
      }
    }
    window.DGState?.writeCart(count);
  }

  function parse(sections) {
    const html = sections?.[SECTION];
    return html ? new DOMParser().parseFromString(html, 'text/html').querySelector('[data-dg-cart-body]') : null;
  }

  // The cart body on screen: the drawer's, which every page but Home carries,
  // else /cart's own.
  function currentBody() {
    return dialog?.querySelector('[data-dg-cart-body]') ?? document.querySelector('[data-dg-cart-page] [data-dg-cart-count]');
  }

  function lines(body) {
    return [...(body?.querySelectorAll('[data-dg-line]') ?? [])].map((li) => ({
      key: li.dataset.dgKey,
      variant: Number(li.dataset.dgVariant),
      quantity: Number(li.dataset.dgQuantity) || 0,
      guide: li.dataset.dgGuide ?? null,
      units: Number(li.dataset.dgUnits) || 1,
      qualifies: li.hasAttribute('data-dg-qualifies'),
    }));
  }

  // variant id -> quantity, for what Undo puts back.
  function quantities(body) {
    const map = new Map();
    for (const line of lines(body)) map.set(line.variant, (map.get(line.variant) ?? 0) + line.quantity);
    return map;
  }

  const total = (body) => Number.parseInt(body?.dataset.dgCartTotal, 10) || 0;

  // The most add-on copies one order may hold: the cap the checkout validation
  // function enforces (dg-addon-validation; pricing-catalog.md › Add-on to any
  // parent order). The rule never prices a cart past it.
  const ADDON_CAP = 4;

  // The cheapest way to hold `copies` grandparent guides: add-ons (at most
  // ADDON_CAP, and only beside a qualifying line or a listed variant of more
  // than one copy) and listed variants. Prices are the variants' own, in cents.
  // Returns { cost, counts: Map variant -> quantity }, or null when no mix of
  // the listed variants makes up the copies.
  function cheapest(copies, qualifying, addon, listed) {
    // best[m][p]: the cheapest listed mix of m copies, p = 1 when it holds a
    // variant of more than one copy (which lets add-ons in), 0 when it does not.
    const best = [[{ cost: 0, from: null }, { cost: Infinity, from: null }]];
    for (let m = 1; m <= copies; m += 1) {
      best[m] = [{ cost: Infinity, from: null }, { cost: Infinity, from: null }];
      listed.forEach(({ units, price }, i) => {
        if (units > m) return;
        for (const before of [0, 1]) {
          const cost = best[m - units][before].cost + price;
          const p = before || units > 1 ? 1 : 0;
          if (cost < best[m][p].cost) best[m][p] = { cost, from: [i, before] };
        }
      });
    }
    let pick = null;
    for (let d = 0; d <= Math.min(ADDON_CAP, copies); d += 1) {
      for (const p of [1, 0]) {
        if (d > 0 && !p && !qualifying) continue;
        const cost = best[copies - d][p].cost + d * addon.price;
        if (cost < (pick?.cost ?? Infinity)) pick = { cost, d, p };
      }
    }
    if (!pick) return null;
    const counts = new Map(pick.d ? [[addon.id, pick.d]] : []);
    for (let m = copies - pick.d, p = pick.p; m > 0; ) {
      const [i, before] = best[m][p].from;
      counts.set(listed[i].id, (counts.get(listed[i].id) ?? 0) + 1);
      m -= listed[i].units;
      p = before;
    }
    return { cost: pick.cost, counts };
  }

  // THE DECISION, the one place it is made: given a rendered cart body, the
  // /cart/update.js updates that put the grandparent guides at the mix the
  // rule wants, or null when they already are.
  function conversion(body) {
    const config = body?.querySelector('[data-dg-guides]');
    if (!config) return null;
    const addon = { id: Number(config.dataset.dgAddon), price: Number.parseInt(config.dataset.dgAddonPrice, 10) };
    const listed = (config.dataset.dgListed ?? '')
      .split(',')
      .filter(Boolean)
      .map((triple) => triple.split(':').map(Number))
      .map(([id, units, price]) => ({ id, units, price }))
      .filter(({ id, units, price }) => id && units > 0 && price >= 0)
      .sort((a, b) => b.units - a.units);
    if (!addon.id || !(addon.price >= 0) || !listed.length) return null;
    const all = lines(body);
    const guides = all.filter((line) => line.guide);
    const qualifying = all.some((line) => line.qualifies);
    if (!guides.length) return null;

    const price = new Map([[addon.id, addon.price], ...listed.map(({ id, price }) => [id, price])]);
    if (guides.some((line) => !price.has(line.variant))) return null; // A guide the rule cannot price; leave the cart as it is.
    const held = new Map();
    for (const line of guides) held.set(line.variant, (held.get(line.variant) ?? 0) + line.quantity);
    const copies = guides.reduce((sum, line) => sum + line.quantity * line.units, 0);
    const target = cheapest(copies, qualifying, addon, listed);
    if (!target) return null; // No variant holds what is left; leave the cart as it is.

    // The cart as it is stays when checkout would take it and nothing cheaper exists.
    const addons = held.get(addon.id) ?? 0;
    const qualified = qualifying || listed.some(({ id, units }) => units > 1 && held.get(id));
    const cost = [...held].reduce((sum, [id, quantity]) => sum + quantity * price.get(id), 0);
    if (addons <= ADDON_CAP && (addons === 0 || qualified) && cost <= target.cost) return null;

    // Per variant: its first line takes the new quantity, any other line 0;
    // a variant not in the cart is added by id.
    const updates = {};
    for (const id of new Set([...held.keys(), ...target.counts.keys()])) {
      const want = target.counts.get(id) ?? 0;
      if (want === (held.get(id) ?? 0)) continue;
      const own = guides.filter((line) => line.variant === id);
      if (!own.length) updates[id] = want;
      own.forEach((line, i) => (updates[line.key] = i === 0 ? want : 0));
    }
    return updates;
  }

  // The lines the change just made took out, as /cart/add.js items: anything
  // whose quantity fell between before and after, grandparent guides aside.
  function removed(before, after) {
    if (!before) return [];
    const items = [];
    const guides = new Set(lines(after).filter((line) => line.guide).map((line) => line.variant));
    const afterQuantities = quantities(after);
    for (const [id, quantity] of before) {
      const now = afterQuantities.get(id) ?? 0;
      if (quantity > now && !guides.has(id)) items.push({ id, quantity: quantity - now });
    }
    return items;
  }

  // The one notice a conversion from total `from` to total `to` shows, in
  // cents: raised (with Undo's lines) when it rose, lowered when it fell, none
  // when it is the same. Raising is tested first, so it wins.
  function pricing(from, to, undoLines) {
    if (to > from) return { kind: 'raised', undo: undoLines };
    if (to < from) return { kind: 'lowered', undo: [] };
    return null;
  }

  // The rule, on the cart as Shopify just returned it. One conversion at most.
  // Returns the sections to render and the notice to show (null for none).
  async function enforce(sections, before) {
    const body = parse(sections);
    const updates = conversion(body);
    if (!updates) return { sections, notice: null };
    const cart = await post('cart/update.js', { updates, sections: SECTION });
    return { sections: cart.sections, notice: pricing(total(body), total(parse(cart.sections)), removed(before, body)) };
  }

  // Every change ends here: the rule, then a re-render (or, on /cart, a
  // reload). cause, when given, is what the celebration is judged from.
  // cause.offer, when given, is the accepted offer: { type, total } (the
  // cart total in cents before it).
  // short: the inbound add left something out, so /cart shows its notice.
  // cause.undone: this settle follows an Undo, so a lowering notice is not
  // shown (owner, 27 Oct 2026); a raising one is.
  async function settle(sections, before = null, cause = null, refused = false, short = false) {
    const { sections: final, notice: found } = await enforce(sections, before);
    const notice = cause?.undone && found?.kind === 'lowered' ? null : found;
    const after = parse(final);
    const joy = cause ? moment(cause, snapshot(after)) : null;
    if (cause?.offer) track('cart_offer_accepted', { type: cause.offer.type, value_change: (total(after) - cause.offer.total) / 100 });
    if (cause?.snap?.band === 'away' && snapshot(after).band === 'reached' && !cause.removal) track('cart_free_shipping_reached');
    finish(final, notice, joy, refused, short);
  }

  function finish(final, notice, joy = null, refused = false, short = false) {
    if (onCartPage) {
      const set = {};
      if (notice) set[NOTICE] = notice.kind === 'lowered' ? 'lower' : notice.undo.map(({ id, quantity }) => `${id}:${quantity}`).join(',');
      if (joy) set[JOY] = joy.combine ? `combine:${joy.combine}` : joy.where;
      if (refused) set[CODE] = 'refused';
      if (short) set[SHORT] = '1';
      // The same cart view continues after the reload.
      window.DGEvents?.carry([...seen]);
      window.location.replace(address(set));
      return;
    }
    render(final, notice, joy);
    if (refused) showCodeError(currentBody());
  }

  // A code Shopify does not apply to this cart: say so, under the field.
  function showCodeError(body) {
    const details = body?.querySelector('.dg-cart__code');
    if (details) details.open = true;
    body?.querySelector('[data-dg-code-error]')?.removeAttribute('hidden');
  }

  // notice: { kind: 'raised' | 'lowered', undo }. Its own copy shows, the
  // other's stays hidden; Undo only on the raising one.
  function showNotice(body, notice) {
    undo = notice?.kind === 'raised' && notice.undo?.length ? notice.undo : null;
    if (!notice) return;
    const box = body?.querySelector('[data-dg-cart-notice]');
    if (!box) return;
    box.querySelectorAll('[data-dg-notice]').forEach((copy) => (copy.hidden = copy.dataset.dgNotice !== notice.kind));
    box.removeAttribute('hidden');
    if (undo) box.querySelector('[data-dg-undo]')?.removeAttribute('hidden');
    if (notice.kind !== 'raised') return;
    if (onCartPage || dialog?.open) track('cart_pricing_notice_shown');
    else noticeUnseen = true;
  }

  function render(sections, notice = null, joy = null) {
    if (!dialog) return;
    const incoming = parse(sections);
    const body = dialog.querySelector('[data-dg-cart-body]');
    if (!incoming || !body) return;
    showNotice(incoming, notice);
    const previous = body.querySelector('[data-dg-saving]')?.textContent.trim() ?? null;
    body.replaceWith(incoming);
    celebrate(incoming, joy, previous);
    wireArrows();
    if (dialog.open) reportOffers();
    setCount(Number.parseInt(incoming.dataset.dgCartCount, 10) || 0);
    // The new total, for the product page's shipping status (dg-product.js).
    document.dispatchEvent(new CustomEvent('dg:cart', { detail: { totalCents: total(incoming) } }));
  }

  function showError() {
    const error = document.querySelector('[data-dg-cart] [data-dg-cart-error], [data-dg-cart-page] [data-dg-cart-error]');
    if (error) error.hidden = false;
  }

  // The page behind is held still while the drawer is open (dg-shop.css,
  // tweak round 7, item 3). A classic scrollbar keeps its gutter, so the
  // page does not shift sideways when it goes.
  //
  // THE CLOSE BUTTON'S RING IS FOR KEYBOARDS (cart foot wallets, owner, 9 Oct
  // 2026). showModal() focuses the close button, and Safari counts that focus
  // as :focus-visible after a tap, since a tapped link takes no focus there,
  // so the ring showed on every open. Opened from a pointer or a touch, focus
  // goes to the dialog itself instead (tabindex -1, no ring of its own, never
  // in the Tab order); the next Tab reaches the close button with its ring.
  // Opened from the keyboard, the close button keeps focus and its ring.
  let keyed = false;
  document.addEventListener('keydown', () => { keyed = true; }, true);
  document.addEventListener('pointerdown', () => { keyed = false; }, true);

  // source: add | icon, for cart_opened.
  function open(source) {
    if (!dialog || dialog.open) return;
    const html = document.documentElement;
    html.toggleAttribute('data-dg-cart-gutter', window.innerWidth - html.clientWidth > 0);
    dialog.showModal();
    if (!keyed) dialog.focus();
    seen = new Set();
    track('cart_opened', { source });
    reportOffers();
    if (noticeUnseen && dialog.querySelector('[data-dg-cart-notice]:not([hidden])')) track('cart_pricing_notice_shown');
    noticeUnseen = false;
  }

  async function post(path, body) {
    const response = await fetch(`${root}${path}`, {
      method: 'POST',
      headers: { Accept: 'application/json', ...(body instanceof FormData ? {} : { 'Content-Type': 'application/json' }) },
      body: body instanceof FormData ? body : JSON.stringify(body),
    });
    if (!response.ok) {
      const error = new Error(`cart ${response.status}`);
      error.status = response.status;
      error.body = await response.json().catch(() => null);
      throw error;
    }
    return response.json();
  }

  async function change(line, quantity) {
    const before = quantities(currentBody());
    const snap = snapshot(currentBody());
    try {
      const cart = await post('cart/change.js', { line, quantity, sections: SECTION });
      await settle(cart.sections, before, { snap });
    } catch {
      showError();
    }
  }

  // Closing the drawer withdraws Undo (cart-redesign piece 4).
  dialog?.addEventListener('close', () => {
    document.documentElement.removeAttribute('data-dg-cart-gutter');
    undo = null;
    noticeUnseen = false;
    dialog.querySelector('[data-dg-cart-notice]')?.setAttribute('hidden', '');
  });

  // Open from the header link; close from the close control or the backdrop.
  document.addEventListener('click', async (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    if (target.closest('[data-dg-cart-link]') && dialog && !onCartPage) {
      event.preventDefault();
      open('icon');
      return;
    }
    if (target.closest('[data-dg-cart-close]') || target === dialog) {
      dialog?.close();
      return;
    }

    // An offer row's arrow: one card along, unless the row is at that end.
    const arrow = target.closest('[data-dg-offer-step]');
    if (arrow) {
      const row = document.getElementById(arrow.getAttribute('aria-controls'));
      if (!row || arrow.getAttribute('aria-disabled') === 'true') return;
      row.scrollBy({ left: Number(arrow.dataset.dgOfferStep) * cardStep(row), behavior: reduced.matches ? 'auto' : 'smooth' });
      return;
    }

    // Undo: the removed lines back, then the rule restores the lower price.
    const undoButton = target.closest('[data-dg-undo]');
    if (undoButton) {
      if (!undo) return;
      const items = undo;
      undo = null;
      undoButton.setAttribute('aria-disabled', 'true');
      track('cart_undo_pressed', {}, undoButton);
      const snap = snapshot(currentBody());
      try {
        const cart = await post('cart/add.js', { items, sections: SECTION });
        await settle(cart.sections, null, { snap, undone: true });
      } catch {
        showError();
      }
      return;
    }

    const remove = target.closest('[data-dg-remove]');
    const step = target.closest('[data-dg-step]');
    const line = (remove ?? step)?.closest('[data-dg-line]');
    if (!line) return;
    event.preventDefault();
    const index = Number.parseInt(line.dataset.dgLine, 10);
    if (remove) {
      track('cart_item_removed', {}, remove);
      return change(index, 0);
    }
    const input = line.querySelector('[data-dg-qty]');
    const next = Math.max(0, (Number.parseInt(input.value, 10) || 0) + Number.parseInt(step.dataset.dgStep, 10));
    input.value = String(next);
    if (next === 0) track('cart_item_removed', {}, step);
    change(index, next);
  });

  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.matches('[data-dg-qty]')) return;
    const line = input.closest('[data-dg-line]');
    const quantity = Math.max(0, Number.parseInt(input.value, 10) || 0);
    if (quantity === 0) track('cart_item_removed', {}, input);
    change(Number.parseInt(line.dataset.dgLine, 10), quantity);
  });

  // An offer or the discount code: the same fields its plain form would post,
  // by fetch.
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-dg-offer]')) return;
    event.preventDefault();
    const button = event.submitter;
    button?.setAttribute('aria-disabled', 'true');
    const before = quantities(currentBody());
    const snap = snapshot(currentBody());
    const totalBefore = total(currentBody());
    try {
      const data = new FormData(form);
      const removal = form.matches('[data-dg-code-remove]');
      const code = form.matches('[data-dg-discount]') && !removal ? String(data.get('discount') ?? '').trim() : null;
      // The codes already working on the cart, so a code that does not apply
      // cannot take them off (Shopify replaces the cart's codes with the one sent).
      const prior = code
        ? ((await (await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } })).json()).discount_codes ?? [])
            .filter((entry) => entry.applicable)
            .map((entry) => entry.code)
        : [];
      data.append('sections', SECTION);
      let cart = await post(form.dataset.dgOffer === 'add' ? 'cart/add.js' : 'cart/update.js', data);
      const refused = Boolean(code) && !cart.discount_codes?.some((entry) => entry.code?.toLowerCase() === code.toLowerCase() && entry.applicable);
      if (refused && prior.length) cart = await post('cart/update.js', { discount: prior.join(','), sections: SECTION });
      if (code) track('cart_discount_applied', { success: !refused }, form);
      const offer = form.dataset.dgOfferType ? { type: form.dataset.dgOfferType, total: totalBefore } : null;
      await settle(cart.sections, before, { snap, offer, combine: form.dataset.dgCombine || null, code: Boolean(code) && !refused, removal }, refused);
    } catch {
      form.submit();
    } finally {
      button?.removeAttribute('aria-disabled');
    }
  });

  wireArrows();
  desktop.addEventListener?.('change', () => document.querySelectorAll('[data-dg-offer-row]').forEach(syncArrows));

  // THE INBOUND ADD: dg_add's value as the snippet left it, on /cart only.
  const INBOUND_LINES = 6;
  const inbound = onCartPage ? document.documentElement.getAttribute('data-dg-add') : null;
  document.documentElement.removeAttribute('data-dg-add');

  const showShort = () => document.querySelector('[data-dg-add-notice]')?.removeAttribute('hidden');

  // The lines worth sending, and whether any was passed over.
  function inboundItems(value) {
    const items = [];
    let short = false;
    for (const pair of value.split(',')) {
      const match = /^([1-9]\d{0,15}):([1-8])$/.exec(pair.trim());
      if (!match || items.length === INBOUND_LINES) {
        short = true;
        continue;
      }
      items.push({ id: Number(match[1]), quantity: Number(match[2]) });
    }
    return { items, short };
  }

  async function addInbound(value) {
    const { items, short } = inboundItems(value);
    if (!items.length) return showShort();
    const snap = snapshot(currentBody());
    let added;
    try {
      added = await post('cart/add.js', { items, sections: SECTION });
    } catch (error) {
      // Refused (sold out, an unknown variant): /cart is drawn again from the
      // cart as Shopify now holds it. No answer: the page already shows it.
      if (error?.status) finish(null, null, null, false, true);
      else showShort();
      return;
    }
    try {
      await settle(added.sections, null, { snap }, false, short);
    } catch {
      // The lines are in; the reload draws them and the rule runs on load.
      finish(null, null, null, false, short);
    }
  }

  // THE RULE ON LOAD. Once, on the cart this page was rendered with. An empty
  // cart is never tested and nothing is requested unless a guide has to
  // change. When one does, the same conversion() decides it and the same
  // finish() shows it: drawn into the drawer, notice open when the total rose
  // (no Undo: nothing here knows what was removed), so it shows the next time
  // the drawer opens; on /cart, a reload. An inbound add takes its place: the
  // rule then runs once, on the cart after the add.
  (async () => {
    if (inbound !== null) return addInbound(inbound);
    const body = currentBody();
    if (!body || !(Number.parseInt(body.dataset.dgCartCount, 10) > 0)) return;
    const updates = conversion(body);
    if (!updates) return;
    try {
      const cart = await post('cart/update.js', { updates, sections: SECTION });
      finish(cart.sections, pricing(total(body), total(parse(cart.sections)), []));
    } catch {
      // Left as it is; the next change in the theme applies the rule.
    }
  })();

  // On /cart: a fresh load opens a cart view; the reload after a change
  // continues the one before it, with the offers it already reported.
  if (onCartPage) {
    const carried = window.DGEvents?.carried();
    if (Array.isArray(carried)) seen = new Set(carried);
    else track('cart_opened', { source: 'page' });
    reportOffers();
  }

  // On /cart, the notice and its Undo carried across the reload.
  if (onCartPage) {
    const url = new URL(window.location.href);
    if (url.searchParams.get(NOTICE) === 'lower') {
      showNotice(document.querySelector('[data-dg-cart-page] [data-dg-cart-count]'), { kind: 'lowered', undo: [] });
    } else if (url.searchParams.has(NOTICE)) {
      const items = (url.searchParams.get(NOTICE) ?? '')
        .split(',')
        .filter(Boolean)
        .map((pair) => pair.split(':').map(Number))
        .filter(([id, quantity]) => id && quantity > 0)
        .map(([id, quantity]) => ({ id, quantity }));
      showNotice(document.querySelector('[data-dg-cart-page] [data-dg-cart-count]'), { kind: 'raised', undo: items });
    }
    // A refused code, carried across the reload: the row open, its error shown.
    if (url.searchParams.has(CODE)) {
      showCodeError(document.querySelector('[data-dg-cart-page] [data-dg-cart-count]'));
    }
    // An inbound add that left something out, carried across the reload.
    if (url.searchParams.has(SHORT)) showShort();
    // Each parameter above is read once, then dropped; the rest stay as they are.
    if ([NOTICE, CODE, SHORT, JOY].some((name) => url.searchParams.has(name))) window.history.replaceState({}, '', address());
    // The moment a change made before the reload (never a plain load: the
    // parameter is written only by finish()), then dropped.
    if (url.searchParams.has(JOY)) {
      const value = url.searchParams.get(JOY) ?? '';
      const joy = value.startsWith('combine:') ? { where: 'saving', combine: value.slice(8) } : { where: value === 'band' ? 'band' : 'saving' };
      // The page was read afresh, so only the combine's words are announced.
      const page = document.querySelector('[data-dg-cart-page] [data-dg-cart-count]');
      celebrate(page, joy, page?.querySelector('[data-dg-saving]')?.textContent.trim() ?? null);
    }
  }

  // Add to cart from any product form, then show the drawer with the line in it.
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-dg-product-form]')) return;
    if (event.submitter?.name === 'checkout') return;
    event.preventDefault();
    const button = form.querySelector('[type="submit"]');
    button?.setAttribute('aria-disabled', 'true');
    const snap = snapshot(currentBody());
    try {
      const data = new FormData(form);
      // The grandparent add-on, where its row is offered and its stepper is above
      // 0, goes in the same /cart/add.js call as the chosen choice (owner, 6 Oct
      // 2026). Without it the form's own fields are posted, as before.
      const addon = form.querySelector('[data-dg-addon]:not([data-dg-off])');
      const extra = Math.max(0, Number.parseInt(addon?.querySelector('[data-dg-addon-qty]')?.value, 10) || 0);
      let added;
      if (extra > 0) {
        added = await post('cart/add.js', {
          items: [
            { id: Number(data.get('id')), quantity: Number(data.get('quantity')) || 1 },
            { id: Number(addon.dataset.dgAddonId), quantity: extra },
          ],
          sections: SECTION,
        });
        addon.querySelector('[data-dg-addon-qty]').value = '0';
      } else {
        data.append('sections', SECTION);
        added = await post('cart/add.js', data);
      }
      await settle(added.sections, null, { snap });
      // The add went through: the product page stops counting its selection
      // toward free shipping, since the cart now holds it (dg-product.js).
      form.dispatchEvent(new CustomEvent('dg:added', { bubbles: true }));
      open('add');
    } catch (error) {
      // A gift card's recipient details Shopify refused (tweak round 9, item
      // 6c): its message and per-field errors go to the recipient form on the
      // page, as Dawn's cartError did, and the page stays. Any other failure
      // posts the form itself, as before.
      if (error?.status === 422 && error.body && form.querySelector('recipient-form')) {
        form.dispatchEvent(new CustomEvent('dg:add-error', {
          bubbles: true,
          detail: { message: error.body.message, errors: error.body.errors || error.body.description },
        }));
      } else {
        form.submit();
      }
    } finally {
      button?.removeAttribute('aria-disabled');
    }
  });

  // Check out, from the drawer or /cart: the cart form posts to /cart with
  // checkout, and the page leaves, so the event goes by sendBeacon.
  document.addEventListener('submit', (event) => {
    if (event.submitter?.name !== 'checkout' || event.target.matches?.('[data-dg-product-form]')) return;
    window.DGEvents?.track('cart_checkout_started', { method: 'button' }, { origin: event.submitter, beacon: true });
  });
})();
